import { createContext, PropsWithChildren, RefObject, useContext, useRef } from 'react';

/**
 * React Context to support deeply nested components using the content div as an anchor
 */
export type ContentContextValues = null | {
	/** Ref to the content div */
	contentDiv: RefObject<HTMLDivElement | null>;
};

/** Context instance */
const ContentContext = createContext<ContentContextValues>(null);

export function ContentContextProvider(props: PropsWithChildren) {
	const contentRef = useRef(null);

	const contentValues: ContentContextValues = {
		contentDiv: contentRef
	};

	return (
		<ContentContext.Provider value={contentValues}>
			<div
				style={{
					overflowY: 'auto',
					width: '100%'
				}}
				ref={contentRef}
			>
				{props.children}
			</div>
		</ContentContext.Provider>
	);
}

/** Exporting hook to access the context instance */
export function useContentContext() {
	const ctx = useContext(ContentContext);
	if (ctx === null) {
		throw new Error('useContentContext must be invoked within a ContentContextProvider');
	}
	return ctx;
}
